/* global $:false */

export default class EnvironmentBar {
  static init () {
    Array.from($('[data-environment-bar]')).map((el) =>
      new EnvironmentBar(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.loadDataAttributes()
    this.setupBindings()
    this.screenResized()
  }

  findElements () {
    this.list = this.el.find('[data-list]')
    this.closeButton = this.el.find('[data-close]')
    this.shrinkButton = this.el.find('[data-shrink]')
    this.expandButton = this.el.find('[data-expand]')
    this.pixels = this.el.find('[data-pixels]')
  }

  setupBindings () {
    this.closeButton.click(event => {
      event.preventDefault()
      this.el.remove()
    })

    this.shrinkButton.click(event => {
      event.preventDefault()
      this.shrink()
    })

    this.expandButton.click(event => {
      event.preventDefault()
      this.expand()
    })

    $(window).on('resize', () => this.screenResized())
  }

  loadDataAttributes () {
    this.url = this.el.data('url')
  }

  screenResized () {
    this.pixels.html(`${window.innerWidth}px`)
  }

  shrink () {
    $.ajax({
      url: this.url,
      data: { _method: 'delete' },
      type: 'POST',
      success: data => {
        this.list.hide()
        this.shrinkButton.hide()
        this.closeButton.hide()
        this.expandButton.show()
      }
    })
  }

  expand () {
    $.ajax({
      url: this.url,
      type: 'POST',
      success: data => {
        this.list.show()
        this.shrinkButton.show()
        this.closeButton.show()
        this.expandButton.hide()
      }
    })
  }
}
